<template>
  <div>
    <h1 class="text-[14px] font-semibold text-[#14171F] mb-4">Verify your business address</h1>
    <div class=" py-2 px-4 incorporated  mb-4">
      <p class="text-[14px] font-normal text-[#383F51]">
        Proof of address can be any of the listed documents below,
        not more than 6 months old and in JPG, JPEG, PNG or PDF.</p>
      <hr>
      <ul>
        <li class="text-[14px] font-normal text-[#383F51]">Utility Bill</li>
        <li class="text-[14px] font-normal text-[#383F51]">Bank Statement</li>
        <li class="text-[14px] font-normal text-[#383F51]">Lease Agreement</li>
      </ul>
    </div>
    <div  class=" py-2 pl-4 flex incorporated items-center gap-4">
      <img src="../../../../../../../../../../assets/images/settings/clue icon.svg" alt="" srcset="">
      <p class="text-[14px] font-normal text-[#383F51]">Upload a JPG, JPEG, PNG, or PDF file only.</p>
    </div>
    
    <!-- <form class="mt-4" v-if="showPOD" @submit.prevent="verify"> -->
    <form class="mt-4"  @submit.prevent="verify">
      <label for="" class="text-[14px] font-semibold text-[#14171F]">Please upload a proof of address</label>
      <input ref="fileInput" type="file" style="display: none;" accept="image/*"
        @change="onFileSelected">
      <button v-if="!imageUrl.verify" @click.prevent="selectImage('verify')"
        class="flex justify-between items-center px-4 py-2 w-[220px]">
        <p class="text-[14px] font-normal text-[#7A90A7]">Upload File </p>
        <img src="../../../../../../../../../../assets/images/ondemand/upload-icon-claim.svg" alt="" srcset="">
      </button>
      <button v-if="imageUrl.verify" class=" flex justify-between items-center px-2 py-2 w-[250px]">
        <img width="" src="../../../../../../../../../../assets/images/ondemand/uploaded-file-icon.svg"
          alt="Selected Image" />
        <p class="text-[14px] font-normal text-[#383F51]">{{ kyc.verify }}</p>
        <img @click.prevent="removeImage(imageUrl.verify, 'verify')"
          src="../../../../../../../../../../assets/images/ondemand/claim-icon-close.svg" alt="" srcset="">
      </button>
      <h1 class="text-[16px] font-normal text-[#14171F] mt-4">Don't have these documents on hand? <span @click="togglePOD">Skip and
          upload later</span></h1>
           <div class="next-submit flex justify-end mt-4">
        <button  type="submit"
          :class="['py-2 px-4 text-[16px] font-semibold text-[#10233E] transition-all duration-300', buttonClass]">
          Save
        </button>
      </div>
    </form>
  </div>
</template>

<script>

export default {
  data() {
    return {
      showPOD: true,
       fileType: '',
      imageUrl: {
        verify: null,
      },
      kyc: {
        verify: null,
      }
    }
  },
  computed: {
     buttonClass() {
            return this.isFormValid
                ? 'opacity-100 cursor-pointer hover:scale-105'
                : 'opacity-50 cursor-not-allowed';
        },
        isFormValid() {
            return (
                this.imageUrl.verify ||
                !this.showPOD
            );
        }
    },
    mounted() {
        const storedData = localStorage.getItem('kycData');

        if (storedData) {
        const parsedData = JSON.parse(storedData);
        this.kyc.verify = parsedData?.data?.org?.proofOfAddress?.documentUrl?.slice(0, 30) + '...';
        this.imageUrl.verify = parsedData?.data?.org?.proofOfAddress?.documentUrl?.slice(0, 30) + '...';
        }      
    },

  methods: {

    togglePOD() {
      this.showPOD = false;
    },
    
    verify() {
      if (this.isFormValid) {
       
        this.$emit('saveBusinessDetails', {
          imageUrl: this.imageUrl.verify,
          showPOD: this.showPOD
        });

      } else {
        this.generateToast("Form is invalid, cannot proceed.", "error");
      }
    },
 
    selectImage(fileType) {
      this.$refs.fileInput.click();
      this.fileType = fileType
    },
    onFileSelected(event) {   
      const file = event.target.files[0];
      if (file.size > 1048576) {
        this.generateToast("Selected image size is too large. Please upload an image smaller than 1MB!", "error");
        return;
      }

      if (this.fileType === 'verify' && file && file.type.startsWith('image/')) {
        this.kyc.verify = file.name;
        this.uploadImage(file, 'verify');
         this.$forceUpdate();     
      }else {
        this.generateToast("Please select a valid image file!", "error");
        this.imageUrl = null;  
      }
      
    },
    async uploadImage(image, type) {
            this.isUploadingImage = true;

            const formData = new FormData();
            formData.append("file", image);
            formData.append("upload_preset", "zunt8yrw");

            try {
                const response = await this.$_uploadImage(formData);
                const imageUrl = response?.data?.fileUrl;

                if (!imageUrl) throw new Error("Upload failed: no URL returned");
                if (type === 'verify' && imageUrl) {
                    this.imageUrl.verify = imageUrl;
                    this.generateToast("Image uploaded", "success");
                }
            } catch (error) {
                this.handleError(error);
            } finally {
                this.isUploadingImage = false;
            }
        },
    removeImage(file, fileType) {
        this.fileType = fileType
    if ( file === this.imageUrl.verify && this.fileType === 'verify'){
        this.imageUrl.verify = null
        this.$refs.fileInput.value = ''; 
      this.$forceUpdate(); 
    }
    },
  }
}

</script>

<style scoped>
hr {
  border: 1px solid #C2C7D6;
  margin: 16px auto;
}

.incorporated {
  border-radius: 8px;
  background-color: #F2F7FC;
}

ul {
  list-style-type: disc;
  padding-left: 20px;
}

ul>li {
  margin-bottom: 8px;
}

span {
  color: #09B78A;
   cursor: pointer;
}
button {
  border: 1px solid #C2C7D6;
  border-radius: 124px;
  /* padding: 8px 16px; */
  background-color: transparent;
  cursor: pointer;
}
.next-submit>button {
    background-color: #FCC210;
    border-radius: 2px;
    /* opacity: 0.5;
    cursor: not-allowed; */
}
</style>
